import { Cookie, getAllUSerList } from "../../../../base/utils";
import { Fragment, useEffect, useState } from "react";

import { AntInput } from "../../antinput";
import { CallPopUpAgentActions } from "../../../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../../../services/call_service";
import { ChatState } from "../../../../base/models/model";
import { CoreServices } from "../../../../base/service/apiServices";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import callChatService from "../../../../base/service/chatService";
import { CallSDK } from "unifiedring-sdk";
import { getAllUsers } from "../../../../store/api/user_management";
import { getContactDetailsWhilegettingCall } from "../../../../store/api/helperspi/contactListapiService";
import { getUser } from "../../../../constants/base/utils";
import styles from "./tabAgentTransfer.module.scss";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userAgentDetail } from "../../../../base/models/callModals";
import { v4 as uuidv4 } from "uuid";
import { Modal } from "antd";
import transferchaticon from '../../../../styles/images/transferringchatsicon.svg'
import { ChatActions } from "../../../../store/slices/chat_slice/chat_slice";

let { CallHold } = CallSDK.Call;

function TabAgentTransfer() {
  const [agentList, setAgentList] = useState<any>([]);
  const isGetAllcontacts: any = useSelector((state: any) => state.contactListForAgent.isGetAllcontacts);

  const agentUserList: any = useSelector((state: any) => state.userList);
  const { users } = agentUserList;
  const allContactList: any = useSelector((state: any) => state.contactListForAgent.allContactList);
  // const callDetails: any = useSelector(
  //   (state: any) => state.callPopUpDetails.callDetails
  // );
  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const LoginUserDetails: any = userDetails;
  const opendialPadDetails: any = useSelector((state: any) => state.callPopUpDetails);
  const { callDetails, incomingCallDetail } = opendialPadDetails;
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const { makeCallFunctionForAll } = CallService(dispatch, navigate);
  // useEffect(() => {
  //   if (!isGetAllcontacts) {
  //     getAllUSerList();
  //   }
  //   setAgentList(allContactList);
  // }, []);

  useEffect(() => {
    dispatch(getAllUsers());
  }, [dispatch]);

  useEffect(() => {
    setAgentList(users);
  }, [users]);

  useEffect(() => {
    setAgentList(users);
  }, []);

  const makeCall = (user: any) => {
    if (chatReducer?.currentSession?.ChatHistoryId && chatReducer?.currentSession?.ChatHistoryId !== "") {
      let data = {
        webChatSessionId: chatReducer?.currentSession?.sessionId,
        domainId: (LoginUserDetails?.domainId),
        ext: user.ext,
        agentName: LoginUserDetails?.profileName,
        sender: chatReducer?.currentSession?.calledPersonDetails,
        ChatHistoryId: chatReducer?.currentSession?.ChatHistoryId.toString(),
        transferType: 1,
        primaryAgent: `${LoginUserDetails?.domainId}_${LoginUserDetails?.ext}`,
        to: `${LoginUserDetails?.domainId}_${user?.ext}`,
        from: chatReducer?.currentSession?.sessionId,
      };
      let data1 = {
        to: `${LoginUserDetails.domainId}_${user.ext}`,
        domainId: (LoginUserDetails?.domainId),
        ext: user.ext,
        status: "transfer"
      }
      dispatch(CallPopUpAgentActions.chatTransferSuccess());
      callChatService.chatTransfer(data);
      callChatService.chatAgentTransfer(data1);
      dispatch(ChatActions.updateTransferModalStatus({

        transferName: user?.UserName,
        ChatHistoryId: chatReducer?.currentSession?.ChatHistoryId,
        istransferringmodal: true,
        istransferring: true,
        istransferSuccess: false,
      }))
      // navigate("/myactivity");
    } else {
      dispatch(CallPopUpAgentActions.updateTransferType({ transfer_type: "AGENT" }));
      // dispatch(CallPopUpAgentActions.setNumber(user.ext));

      // await getContactDetailsWhilegettingCall(ext).then((res: any) => {
      //   if (res?.data?.statusCode === 200) {
      //     contactDetails = res?.data?.getContactNumberRes[0];
      //   } else {
      //     contactDetails.calledPersonDetails = {};
      //   }
      //   if (!contactDetails.hasOwnProperty("firstName")) {
      //     contactDetails = getUser(ext) ?? {};
      //   }
      //   makeCallFunctionForAll(ext, 1, contactDetails);
      // });

      // contactDetails = (await getUser(ext)) ?? {};
      makeCallFunctionForAll(user.ext, 1, user);
    }
  };

  // const getAgentList = async(e: any) => {
  //   if (e?.target?.value?.trim() !== "") {
  //     await CoreServices.get(`/get_all_user_list?name=${e.target.value}`).then((value) => {
  //       //setAgentList(value.data.getAllUserList);

  //         const _users = agentsWithVoice.filter((el:any)=>{return el.UserName.toLowerCase().includes(e?.target?.value?.trim().toLowerCase())});
  //       setAgentList(_users);
  //     });
  //   } else {
  //     //setAgentList(allContactList);
  //     setAgentList(users);
  //   }
  // };
  const getAgentList = async (e: any) => {
    if (e?.target?.value?.trim() !== "") {
      const _users = users.filter((agent: { UserName: any; }) => agent.UserName.toLowerCase().includes((e?.target?.value?.trim().toLowerCase())))
      setAgentList(_users);
    } else {
      setAgentList(users);

    }
  }
  const agentsWithChat = [] as any;
  const agentsWithVoice = [] as any;


  agentList.forEach((user: { chat: any; voice: any; socialMedia: any; inboundCall: any }) => {
    if (user.chat) agentsWithChat.push(user);
    if (user.voice && user?.inboundCall) agentsWithVoice.push(user);

  });
  return (
    <>
      <div className={`${styles.callcontainartopsec}`}>
        <AntInput className="transferSearch searchbordered" onChange={getAgentList} placeHolder="Search" />
        <div className={styles.agentsList}>
          {(chatReducer?.currentSession?.ChatHistoryId && agentsWithChat.length <= 1) ||
            (chatReducer?.currentSession?.CallHistoryId && agentsWithVoice.length <= 1) ? (
            <span className={styles.nodatatxt}>No data</span>
          ) : (chatReducer?.currentSession?.ChatHistoryId != null
            ? agentsWithChat.map((data: any, idx: any) => {
              if (
                ['3', '5', '6'].includes(`${data.roleid}`) &&
                parseInt(data.ext) !== parseInt(LoginUserDetails?.ext)
              ) {
                return (
                  <Fragment key={idx}>
                    {
                      // data?.statusName === "Ready" || data?.statusName === "Transfer Only" ? (
                      (data?.isChatTransfer_AgentStatus === 1 || data.isChat === 1) ? (
                        <div className={`${styles.users}`} onClick={() => makeCall(data)}>
                          <div className={styles.callStatus}>
                            <div className={styles.ready}></div>
                          </div>
                          <div className={styles.userDetails}>
                            <span className={styles.agentName}>{data?.UserName}</span>
                            <span className={styles.agentNumber}>{data?.statusName}</span>
                          </div>
                        </div>
                      ) : (
                        // : data?.status === 'busy' ?
                        <div className={`${styles.users} ${styles.onHold}`}>
                          <div className={styles.callStatus}>
                            {data?.statusName?.toLowerCase() === "ready" ||
                                    data?.statusName?.toLowerCase() === "not ready" ||
                                    data?.statusName?.toLowerCase() === "transfer only" ||
                                    data?.statusName?.toLowerCase() === "away" ||
                                    data?.statusName?.toLowerCase() === "busy" ||
                                    data?.statusName?.toLowerCase() === "offline" ? (
                                    <div
                                      className={
                                        data?.statusName?.toLowerCase() === "ready"
                                          ? `${styles.ready} ${styles.whiteDot}`
                                          : data?.statusName?.toLowerCase() === "not ready"
                                            ? `${styles.notReady} ${styles.whiteDot}`
                                            : data?.statusName?.toLowerCase() === "transfer only"
                                              ? `${styles.transferOnly} ${styles.whiteDot}`
                                              : data?.statusName?.toLowerCase() === "busy"
                                                ? `${styles.busy} ${styles.whiteDot}`
                                                : data?.statusName?.toLowerCase() === "away"
                                                  ? `${styles.break} ${styles.whiteDot}`
                                                  : `${styles.offline} ${styles.whiteDot}`
                                      }
                                    ></div>
                                  ) : (
                                    <div style={{ backgroundColor: data?.colorCode ?? "red" }} className={styles.whiteDot}></div>
                                  )}
                          </div>
                          <div className={styles.userDetails}>
                            <span className={styles.agentName}>{data?.UserName}</span>
                            <span className={styles.agentNumber}>{data?.statusName}</span>
                          </div>
                        </div>
                      )
                    }
                  </Fragment>
                );
              }
            })
            : (chatReducer?.currentSession?.CallHistoryId != null
              ? agentsWithVoice.map((data: any, idx: any) => {
                if (
                  ['3', '5', '6'].includes(`${data.roleid}`) &&
                  parseInt(data.ext) !== parseInt(LoginUserDetails?.ext)
                ) {
                  return (
                    <Fragment key={idx}>
                      {
                        // data?.statusName === "Ready" || data?.statusName === "Transfer Only" ? (
                        (data?.isVoiceCallTransfer_AgentStatus === 1 || data?.isVoice === 1) ? (
                          <div className={`${styles.users}`} onClick={() => makeCall(data)}>
                            <div className={styles.callStatus}>
                              <div className={`${styles.ready} ${styles.whiteDot}`}></div>
                            </div>
                            <div className={styles.userDetails}>
                              <span className={styles.agentName}>{data?.UserName}</span>
                              <span className={styles.agentNumber}>{data?.statusName}</span>
                            </div>
                          </div>
                        ) : (  // : data?.status === 'busy' ?
                          <div className={`${styles.users} ${styles.onHold}`}>
                              <div className={styles.callStatus}>
                                {data?.statusName?.toLowerCase() === "ready" ||
                                  data?.statusName?.toLowerCase() === "not ready" ||
                                  data?.statusName?.toLowerCase() === "transfer only" ||
                                  data?.statusName?.toLowerCase() === "away" ||
                                  data?.statusName?.toLowerCase() === "busy" ||
                                  data?.statusName?.toLowerCase() === "offline" ? (
                                  <div
                                    className={
                                      data?.statusName?.toLowerCase() === "ready"
                                        ? `${styles.ready} ${styles.whiteDot}`
                                        : data?.statusName?.toLowerCase() === "not ready"
                                          ? `${styles.notReady} ${styles.whiteDot}`
                                          : data?.statusName?.toLowerCase() === "transfer only"
                                            ? `${styles.transferOnly} ${styles.whiteDot}`
                                            : data?.statusName?.toLowerCase() === "busy"
                                              ? `${styles.busy} ${styles.whiteDot}`
                                              : data?.statusName?.toLowerCase() === "away"
                                                ? `${styles.break} ${styles.whiteDot}`
                                                : `${styles.offline} ${styles.whiteDot}`
                                    }
                                  ></div>
                                ) : (
                                  <div style={{ backgroundColor: data?.colorCode ?? "red" }} className={styles.whiteDot}></div>
                                )}
                              </div>
                            <div className={styles.userDetails}>
                              <span className={styles.agentName}>{data?.UserName}</span>
                              <span className={styles.agentNumber}>{data?.statusName}</span>
                            </div>
                          </div>
                        )                      // :
                        // data?.status === 'offline' ?
                        // <div className={styles.users}>
                        //   <div className={styles.callStatus}>
                        //     <div className={styles.offLine}></div>
                        //   </div>
                        //   <div className={styles.userDetails}>
                        //     <span className={styles.agentName}>{data?.name}</span>
                        //     <span className={styles.agentNumber}>{data?.statusName === null ? "Ready" : "Busy"}</span>
                        //   </div>
                        // </div>
                        // :
                        // "No data"

                      }
                    </Fragment>
                  );
                }
              })
              : "No data"
            )
          )
          }
        </div>
      </div>
    </>
  );
}

export default TabAgentTransfer;
